import {buildDashboardPoiApiUrl} from "api/configuration";
import {DateInterval} from "api/report";
import {http} from "../../http";
import {PoiDashboardStats} from "../index";

export interface PoiDashboardFilter {
  operatorIds?: string[];
  carrierIds?: string[];
  startPeriod?: DateInterval;
  endPeriod?: DateInterval;
  territoryCodes?: string[];
}

export const fetchPoiDashboardStats = (
  filter: PoiDashboardFilter
): Promise<PoiDashboardStats> => {
  const {
    territoryCodes,
    carrierIds,
    operatorIds,
    startPeriod,
    endPeriod
  } = filter;
  return http.post(
    buildDashboardPoiApiUrl("/poidashboard"),
    JSON.stringify({
      payload: {
        operatorIds: operatorIds,
        carrierIds: carrierIds,
        startPeriod: startPeriod,
        endPeriod: endPeriod,
        territoryCodes: territoryCodes
      },
    })
  );
};
